// extracted by mini-css-extract-plugin
export default {"bottomNav":"styles_bottomNav__7El7Q","navItem":"styles_navItem__2VrfT","active":"styles_active__L7btA","navLabel":"styles_navLabel__+Cxhj"};